module.exports = __webpack_public_path__ + "media/images/how_it_works/hiw-24d600d4a2ce54465e177022e7e2904d.jpg";